import React from 'react';
import { Separator } from './separator';
import { cn } from '@/shared/lib/cn';

interface PageHeaderProps {
  title: string;
  subtitle: string;
  /** Hero scale for the landing/about page name. */
  hero?: boolean;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  hero = false,
}) => {
  return (
    <header className="space-y-6 pb-8">
      <div className="space-y-1.5">
        <h1
          className={cn(
            'font-semibold tracking-tight',
            hero ? 'text-4xl sm:text-5xl' : 'text-2xl sm:text-3xl',
          )}
        >
          {title}
        </h1>
        <p className={cn('text-muted-foreground', hero && 'text-lg')}>
          {subtitle}
        </p>
      </div>
      <Separator className="bg-border/60" />
    </header>
  );
};
